<template>
  <mu-content-block class="cta-payment">


    <h2>{{$t('message.paymentCtaUpgrade')}}</h2>


    <div class="media">
      <div class="media-left">
        <mu-icon value="check"></mu-icon>
      </div>
      <div class="media-right">
        {{$t('message.paymentCtaEducation')}}
      </div>
    </div>


    <div class="media">
      <div class="media-left">
        <mu-icon value="check"></mu-icon>
      </div>
      <div class="media-right">
        {{$t('message.paymentCtaCommunitySupport')}}
      </div>
    </div>




    <div class="media">
      <div class="media-left">
        <mu-icon value="check"></mu-icon>
      </div>
      <div class="media-right">
       {{$t('message.paymentCtaResources')}}

      </div>
    </div>

    <div class="media">
      <div class="media-left">
        <mu-icon value="check"></mu-icon>
      </div>
      <div class="media-right">
       {{$t('message.paymentCtaMealPlans')}}

      </div>
    </div>

    <div class="media">
      <div class="media-left">
        <mu-icon value="check"></mu-icon>
      </div>
      <div class="media-right">
        {{$t('message.paymentCtaUpdatesInformation')}}

      </div>
    </div>

    <div class="media">
      <div class="media-left">
        <mu-icon value="check"></mu-icon>
      </div>
      <div class="media-right">
       {{$t('message.paymentCtaFriendlySupport')}}
      </div>
    </div>


    <mu-raised-button style="margin-top: 8px;margin-bottom: 8px" fullWidth :label="$t('message.labelUpgrade')" @click.native="goToPayment"></mu-raised-button>


  </mu-content-block>
</template>

<script>

  import paymentApi from '../../api/Payment'

  export default {
    name: "payment-call-to-action",
    data() {
      return {
        paypal: null
      }
    },
    mounted() {
      this.fetchPaymentDetails();

    },
    methods: {
      goToPayment() {
        let self = this;
        self.$router.push({
          name: 'Payment'
        })
      },
      fetchPaymentDetails() {
        let self = this;
        paymentApi.getPayPalDetails().then(response => {
          self.paypal = response.data;
        }).catch(error => {
        });
      },
    }
  }
</script>

<style>


  .cta-payment  .media, .media-body {
    overflow: hidden;
    zoom: 1;
  }

  .cta-payment .media {
    margin-bottom: 8px;
  }

  .cta-payment  .media-body, .media-left, .media-right {
    display: table-cell;
    vertical-align: middle;
  }


  .cta-payment .media-right {
    padding-left: 14px;
  }


  .cta-payment {
    box-sizing: border-box !important;
    background: #0179d5;
    color: white;
  }

  .cta-payment ul {
    margin-left: 0;
    padding-left: 0;
  }

  .cta-payment h2 {
    font-size: 16px;
    margin-top: 8px;
  }

  .cta-payment ul li {
    list-style-type: none  !important
  }

</style>



// WEBPACK FOOTER //
// PaymentCallToAction.vue?2b5dda4c